function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

export var didPropsChange = function didPropsChange(prevProps, nextProps) {
  if (Object.keys(prevProps).length !== Object.keys(nextProps).length) {
    return true;
  }

  return Object.keys(nextProps).some(function (propName) {
    var prevValue = prevProps[propName];
    var nextValue = nextProps[propName];

    if (prevValue && nextValue) {
      if (typeof prevValue === 'function' && typeof nextValue === 'function') {
        return prevValue.toString() !== nextValue.toString();
      }

      if (_typeof(prevValue) === 'object' && _typeof(nextValue) === 'object') {
        return didPropsChange(prevValue, nextValue);
      }
    }

    return prevValue !== nextValue;
  });
};